export class OfferFromCompany {
    title:string = '';
    description:string = '';
    responsibleId:string | null = null;
    customer: OfferFromCompanyCustomer = new OfferFromCompanyCustomer();
    delivery: OfferFromCompanyDelivery = new OfferFromCompanyDelivery();
    contactId:string | null = null;
    offerTypeId:string | null = null;
    caseId:string | null = null;
    vorRef:string = '';
    requisitionNumber:string = '';
    departmentId:string | null = null;
    channelId:string | null = null;
    notificationSetId: string | null = null;
    receiver:string | null = 'customer';
}

export class OfferFromCompanyCustomer {
    customerId: string | null = null;
    customerNumber: string = '';
    customerName: string = '';
    customerAddress: string = '';
    customerCity: string = '';
    customerZipCode: string = '';
    customerEmail: string = '';
    customerMobileNumber: string = '';
    invoiceName: string = '';
    invoiceAddress: string = '';
    invoiceCity: string = '';
    invoiceZipCode: string = '';
    invoiceEmail: string = '';
    invoiceMobileNumber: string = '';
    cvr:string = '';
    att:string = '';
}

export class OfferFromCompanyDelivery {
    deliveryId:string | null = null;
    name: string | null = null;
    address:string | null = null;
    city:string | null = null;
    zipCode:string | null = null;
    email:string | null = null;
    mobileNumber:string | null = null
}

export class OfferOnExistingCase {
    caseId: string | null = null;
    offerTypeId: string | null = null;
    title: string = '';
    description: string = '';
    responsibleId: string | null = null;
    caseChannel: string | null = null;
    caseStage: string | null = null;
}